import ajax from '@/utils/ajax'

/**
 * 首页弹窗
 */
// 获取显示展示字段
export const getAdvertisementList = params => ajax.post('advertisement/getAdvertisementList', params)

// 已读
export const readMark = params => ajax.post('advertisement/readMark', params)

// 获取商户规则弹窗
export const getRulePop = params => ajax.post('login/whetherRead', params)
